import styled from "@emotion/styled";
import { useEffect, useRef } from "react";

const DubbedScript = ({ activeNumber, scriptData }: any) => {
  const listRef = useRef();
  const height = useRef(0);

  useEffect(() => {
    const item = listRef.current.children;
    if (item.length > 0) {
      if (activeNumber < 2) {
        height.current = 0;
        listRef.current.style.transition = `all 1s`;
        listRef.current.style.transform = `translateY(0px)`;
        return;
      }

      if (activeNumber >= 2) {
        height.current += item[activeNumber - 2].offsetHeight + 20;
        listRef.current.style.transition = `all 1s`;
        listRef.current.style.transform = `translateY(-${
          height.current - 12
        }px)`;
      }
    }
  }, [activeNumber]);

  return (
    <Section>
      <ScriptList ref={listRef}>
        {scriptData.map((el, i) => (
          <ScriptContent key={el.script_num} active={activeNumber === i + 1}>
            {el.script}
          </ScriptContent>
        ))}
      </ScriptList>
    </Section>
  );
};

const Section = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 92px 0 20px;
  overflow: hidden;
`;

const ScriptList = styled.div``;

const ScriptContent = styled.div<{ active: boolean }>`
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  height: auto;
  display: -webkit-box;
  -webkit-line-clamp: 10; // 원하는 라인수
  -webkit-box-orient: vertical;
  width: 100%;
  background: black;

  @keyframes fade {
    from {
      opacity: 0.6;
    }
    to {
      opacity: 1;
    }
  }

  font-size: var(--fs-b1);
  line-height: var(--lh-b1);
  font-weight: 400;
  color: var(--white);
  opacity: 0.6;
  text-align: left;
  margin-top: 20px;
  ${({ active }) =>
    active &&
    `font-size: var(--fs-h4);
    line-height: var(--lh-h4);
    font-weight: 600;
    animation: fade 1s forwards;
    `}
`;

export default DubbedScript;
